module.exports = __webpack_public_path__ + "media/feedback-3-df0eb7b193c79c713fe1b9b88637104d.png";